import { defineStore } from 'pinia'

export const useReportCardStore = defineStore({
    id: 'reportCard',

    state () {
        return {
            cards: [],
            hydrated: false,
            hydrating: false
        }
    },

    getters: {
        getCourseCard (state) {
            return (course) => {
                let id = course;

                if (typeof course == 'object' && course.id) id = course.id;
                if (typeof id != 'string') return false;

                return state.cards.find(card => {
                    if (typeof card.course == 'object') return card.course.id == id;
                    if (typeof card.course != 'string') return false;
                    return card.course == id;
                });
            }
        },

        hasCertificate (state) {
            return state.cards.some(o => o.certificateId)
        },

        getCourses (state) {
            return state.cards.filter(o => o.course.type != 'event')
        },

        getEvents (state) {
            return state.cards.filter(o => o.course.type == 'event')
        }
    },

    actions: {
        sort () {
            this.cards.sort((a, b) => new Date(b.interactionDate) - new Date(a.interactionDate))
        },

        add (card) {
            if (this.cards.findIndex(item => item.id === card.id) < 0) {
                this.cards.push(card);
                this.sort();
            }
        },

        remove (card) {
            let index = this.cards.findIndex(item => item.id === card.id);
            if (index >= 0) this.cards.splice(index, 1);
        },

        update (card) {
            let index = this.cards.findIndex(item => item.id === card.id);

            if (index >= 0) {
                this.cards[index] = card;
                this.sort();
            }
        },

        updateCard ({id, update}) {
            let card = this.cards.find(card => card.id === id);
            if (card) {
                Object.assign(card, update);
                this.sort();
            }
        },

        async hydrate() {
            // Prevent request for non logined users
            if (!this.$nuxt.$auth.user) return this.hydrated = true;

            if (this.hydrating) return;
            this.hydrating = true;

            let data = await this.$nuxt.$axios.$get('/reportcard/list', {
                params: { noEvents: false },
                progress: false,
            })
            .catch(() => {});

            if (data && data.cards)   this.cards = data.cards;

            this.hydrated = true;
            this.hydrating = false;
        },

        async setStatus({id, status}) {
            let card = this.cards.find(card => card.id == id);
            if (!card) return;

            card = this.$nuxt.$structuredClone(card);

            this.updateCard({id, update: {status}});

            this.$nuxt.$axios.$post(
                '/reportcard/setstatus',
                { id, status },
                { progress: false }
            )
            .then(res => {
                let icon = 'icon-ic-restore';
                switch (status) {
                    case "archived":
                        icon = 'icon-ic-archive';
                        break;
                    default:
                        icon = 'icon-ic-restore';
                }

                this.$nuxt.$toastStore.add({
                    title: this.$nuxt.i18n.t(`courseSettings.${status}Toast.title`, {name: card.course.name}),
                    text: this.$nuxt.i18n.t(`courseSettings.${status}Toast.text`),
                    icon
                });
            })
            .catch(err => {
                console.log(err);
                this.updateCard({id, update: {status: card.status}});

                this.$nuxt.$toastStore.add({
                    title: this.$nuxt.i18n.t(`courseSettings.${status}Toast.titleFail`, {name: card.course.name}),
                    text: this.$nuxt.i18n.t(`courseSettings.toastTextFail`),
                    icon: 'icon-ic-dismiss',
                    autoClose: 9000
                });
            });
        },

        socketUpdate (card) {
            let index = this.cards.findIndex(item => item.id === card.id);

            if (index < 0) this.cards.push(card);
            else this.cards[index] = card;

            this.sort();
        }
    }
});
